import "../public/styles/global.css";
import React, { Fragment } from "react";
import { GoogleTagManager } from "@next/third-parties/google";

import type { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import { AuthProvider } from "../contexts/AuthContext";
import { LayoutProvider } from "../contexts/LayoutContext";
import Layout from "../components/Layout";
import AuthGuard from "../components/AuthGuard";

// Define pages that should NOT use the common layout
const PAGES_WITHOUT_LAYOUT = [
  "/",
  "/callback",
  "/logout",
  "/signup",
  "/mobile-home",
  "/import-gstin",
  "/404",
  "/_error",
  "/post-signUp-mobile",
  "/access-denied",
  "/balance-confirmations/counterparty",
  "/balance-confirmations/handoff",
  "/start-free"
];

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const isProd = process.env.NODE_ENV === "production";
  const faviconPath = isProd ? "/Favicon.ico" : "/Favicon-dev.ico";

  // Check if current page should use layout
  const shouldUseLayout = !PAGES_WITHOUT_LAYOUT.includes(router.pathname);

  return (
    <Fragment>
      <Head>
        <title>OneCap</title>
        <link rel="icon" href={faviconPath} type="image/x-icon" />
      </Head>
      <GoogleTagManager gtmId="GTM-NR2HB54M" />
      <AuthProvider>
        <AuthGuard>
          <LayoutProvider>
            {shouldUseLayout ? (
              <Layout>
                <Component {...pageProps} />
              </Layout>
            ) : (
              <Component {...pageProps} />
            )}
          </LayoutProvider>
        </AuthGuard>
      </AuthProvider>
    </Fragment>
  );
}
